import IonIcon from '@reacticons/ionicons'
import React from 'react'

/**
 * Primary UI component for user interaction lock-open
 */
export const LockOpenComponent: React.FC = () => {
  return (
    <div className="flex flex-col items-center mt-[13px] mb-4 ml-[28px] !w-[16px] !h-[16px]">
      <IonIcon name="lock-open" className="mr-2 text-navy flex-shrink-0 !w-[16px] !h-[16px]" />
    </div>
  )
}
